import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@material-ui/core";
import { CommonConfig } from "CommonConfig";
import GridContainer from "components/Grid/GridContainer";
import { InputText } from "primereact/inputtext";
import api from "utils/api";
import APIConstant from "utils/constant";
import GridItem from "components/Grid/GridItem";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import cogoToast from "cogo-toast";
import { MultiSelect } from "primereact/multiselect";

const initialBranchDetails = {
  name: "",
  nameErr: "",
  nameErrText: "",
  contact: "",
  address: "",
  users: [],
};

const BranchMaster = (props) => {
  const [userId, setUserId] = useState("");
  const [branchId, setBranchId] = useState("");
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [addBranchDialog, setAddBranchDialog] = useState(false);
  const [deleteBranchDialog, setDeleteBranchDialog] = useState(false);
  const [readOnly, setReadOnly] = useState(false);
  const [search, setSearch] = useState("");
  const [branchDetails, setBranchDetails] = useState(initialBranchDetails);
  const [branchList, setBranchList] = useState([]);
  const [userList, setUserList] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [rowsPerPageOptions, setRowsPerPageOptions] = useState(
    CommonConfig.dataTableConfig.rowsPerPageOptions
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    CommonConfig.dataTableConfig.rowsPerPage
  );

  useEffect(() => {
    let data = localStorage.getItem("Infodata");
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");

    // if (lockstatus == 0) {
    if (token !== null) {
      setUserId(data);
      setUserPageAccess(userPageAccess);
      getUsers(data);
      getBranchMaster(data);
    } else {
      props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  }, []);

  const getBranchMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetBranchMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          setBranchList(response.Data);
        }
      })
      .catch((err) => {});
  };
  const getUsers = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetOrganisationUsers, params)
      .then((response) => {
        if (response.Success === 1) {
          setUserList(response.Data);
          setCurrentUser(response.User);
        }
      })
      .catch((err) => {});
  };

  const validate = () => {
    let isValid = true;
    if (CommonConfig.isEmpty(branchDetails.name)) {
      isValid = false;
      setBranchDetails((prevState) => ({
        ...prevState,
        nameErr: true,
        nameErrText: "Name is required",
      }));
    }

    return isValid;
  };

  const addUpdateBranch = async () => {
    if (validate()) {
      let params = {
        BranchId: branchId,
        BranchName: branchDetails.name,
        Address: branchDetails.address,
        Contact: branchDetails.contact,
        Users: branchDetails.users,
        UserId: userId,
      };
      api
        .post(APIConstant.path.AddUpdateBranchMaster, params)
        .then((response) => {
          if (response.Success === 1) {
            handleClose("AddBranch");
            getBranchMaster(userId);
            cogoToast.success(response.Message);
          } else {
            cogoToast.error(response.Message);
          }
        })
        .catch((err) => {});
    }
  };

  const getBranchMasterById = async (id) => {
    let params = {
      BranchId: id,
      UserId: userId,
    };
    api
      .post(APIConstant.path.GetBranchMasterById, params)
      .then((response) => {
        if (response.Success === 1) {
          let data = response.Data;
          setBranchDetails({
            name: data.BranchName,
            contact: data.Contact,
            address: data.Address,
            users: data.Users,
            type: data.Type,
            owner: data.UserId,
          });
        }
      })
      .catch((err) => {});
  };

  const deleteBranch = async () => {
    let params = {
      BranchId: branchId,
      UserId: userId,
    };
    api
      .post(APIConstant.path.DeleteBranchMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          handleClose("DeleteMasterType");
          cogoToast.success(response.Message);
          getBranchMaster(userId);
        }
      })
      .catch((err) => {});
  };

  const actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        {userPageAccess.includes("View Branch") ? (
          <i
            class="icon-view"
            onClick={(e) => handleOpen(rowData, "ViewMasterType")}
          ></i>
        ) : null}
        {userPageAccess.includes("Edit Branch") ? (
          <i
            onClick={(e) => handleOpen(rowData, "EditMasterType")}
            class="icon-editImage"
          ></i>
        ) : null}
        {userPageAccess.includes("Delete Branch") ? (
          <i
            onClick={(e) => handleOpen(rowData, "DeleteMasterType")}
            class="icon-delete"
          ></i>
        ) : null}
      </div>
    );
  };

  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const handleOpen = async (e, type) => {
    if (type === "AddBranch") {
      setAddBranchDialog(true);
    } else if (type === "ViewMasterType") {
      setBranchId(e._id);
      await getBranchMasterById(e._id);
      setReadOnly(true);
      setAddBranchDialog(true);
    } else if (type === "EditMasterType") {
      setBranchId(e._id);
      // await getSubWareHouseList(e.ItemId);
      await getBranchMasterById(e._id);
      setAddBranchDialog(true);
    } else if (type === "DeleteMasterType") {
      setBranchId(e._id);
      setDeleteBranchDialog(true);
    }
  };

  const handleChange = async (value, field, regex) => {
    if (!value) {
      setBranchDetails((prev) => ({
        ...prev,
        [field]: "",
        [`${field}Err`]: true,
        [`${field}ErrText`]: `This field is required`,
      }));
    } else {
      if (!regex || regex.test(value)) {
        let extraObj = {};
        setBranchDetails((prev) => ({
          ...prev,
          [field]: value,
          [`${field}Err`]: false,
          [`${field}ErrText`]: "",
          ...extraObj,
        }));
      }
    }
  };

  const handleClose = (type) => {
    if (type === "AddBranch") {
      setAddBranchDialog(false);
      setReadOnly(false);
      setBranchId("");
      setBranchDetails(initialBranchDetails);
    } else if (type === "DeleteMasterType") {
      setDeleteBranchDialog(false);
      setBranchId("");
    }
  };

  const a11yProps = (index) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-cog"></i>
          <h2>Branch Master</h2>
        </div>
        <div className="heading-area-right p-d-lg-flex p-ai-center ">
          <div className="searchbar-area p-as-center">
            <InputText
              type="search"
              onInput={(e) => setSearch(e.target.value)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 10 }}
            />
            <i className="icon-search"></i>
          </div>
          {userPageAccess.includes("Add Branch") ? (
            <div>
              <div
                className="e-add-btn"
                onClick={(e) => handleOpen(e, "AddBranch")}
              >
                <i className="icon-add"></i>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <hr />
      <div className="main-access-card-master e-card-master">
        <DataTable
          className="main-table table-td e-company-table"
          // style={{ height: "calc(100vh - 196px)" }}
          value={branchList}
          editMode="row"
          dataKey="id"
          responsiveLayout="scroll"
          paginator={true}
          rows={rowsPerPage}
          totalRecords={branchList.length}
          rowsPerPageOptions={rowsPerPageOptions}
          globalFilter={search}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "5%" }}
          ></Column>
          <Column
            field="BranchName"
            header="Branch Name"
            style={{ width: "15%" }}
          ></Column>
          <Column
            field="Address"
            header="Address"
            style={{ width: "15%" }}
          ></Column>
          <Column
            field="Contact"
            header="Contact"
            style={{ width: "15%" }}
          ></Column>
          <Column
            field="Users"
            header="Users"
            style={{ width: "15%" }}
            body={(rowData) => {
              let tempList = [];
              rowData.Users.forEach((user) => {
                let name = userList.find((u) => u.value === user)?.label;
                if (name) {
                  tempList.push(name);
                }
              });
              return tempList.join(", ");
            }}
          ></Column>
          <Column
            field="Action"
            header="Action"
            body={actionTemplate}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          ></Column>
        </DataTable>
      </div>

      <Dialog
        className="stock-modal"
        open={addBranchDialog}
        onClose={() => handleClose("AddBranch")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Add Branch</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("AddBranch")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <GridContainer>
          <GridItem xs={12}>
            <div className="p-w-100">
              <div className="custom-inputs e-order-mng p-mt-3">
                <label className="input-text">Branch Name</label>
                <InputText
                  placeholder="Name"
                  maxLength={50}
                  value={branchDetails.name}
                  onChange={(e) => handleChange(e.target.value, "name")}
                  className="p-w-100"
                />
                <span className="error-msg" style={{ color: "red" }}>
                  {branchDetails.nameErr ? branchDetails.nameErrText : null}
                </span>
              </div>
            </div>
          </GridItem>
          <GridItem xs={12}>
            <div className="p-w-100">
              <div className="custom-inputs e-order-mng p-mt-3">
                <label className="input-text">Address</label>
                <InputText
                  placeholder="Address"
                  maxLength={200}
                  value={branchDetails.address}
                  onChange={(e) => handleChange(e.target.value, "address")}
                  className="p-w-100"
                />
              </div>
            </div>
          </GridItem>
          <GridItem xs={12}>
            <div className="p-w-100">
              <div className="custom-inputs e-order-mng p-mt-3">
                <label className="input-text">Contact</label>
                <InputText
                  placeholder="contact"
                  maxLength={10}
                  value={branchDetails.contact}
                  onChange={(e) =>
                    handleChange(e.target.value, "contact", /^\d*$/i)
                  }
                  className="p-w-100"
                />
              </div>
            </div>
          </GridItem>
          <GridItem xs={12}>
            <div className="p-w-100">
              <div className="custom-inputs e-order-mng p-mt-3">
                <label className="input-text">Users</label>
                <MultiSelect
                  value={branchDetails.users}
                  onChange={(e) => handleChange(e.target.value, "users")}
                  options={
                    branchDetails.type === "default"
                      ? [...userList, currentUser]
                      : userList
                  }
                  optionDisabled={(option) =>
                    option.value === currentUser.value
                  }
                  optionLabel="label"
                  placeholder="Select Users"
                  className="w-full md:w-20rem"
                />
              </div>
            </div>
          </GridItem>
        </GridContainer>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("AddBranch")}
          >
            Cancel
          </Button>
          {!readOnly && (
            <Button
              className="primary-btn"
              onClick={(e) => addUpdateBranch(e)}
              type="submit"
            >
              Submit
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteBranchDialog}
        onClose={() => handleClose("DeleteMasterType")}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Branch</div>
          <div
            className="dialog-close"
            onClick={(e) => handleClose("DeleteMasterType")}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("DeleteMasterType")}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => deleteBranch(e)}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BranchMaster;
